import React from 'react'
import { Tabs } from 'antd'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import FuelManagement from './FuelManagement'
import LocomotiveFM from './LocomotiveFM'
import { useState } from 'react'


const FuelManagementMainPage = () => {

    const [tabToRender, setTabToRender] = useState("1")

    let items = [
        {
            key: '1',
            label: 'Fuel Management',
            children: <FuelManagement currentTab={tabToRender} />,
        },
        {
            key: '2',
            label: 'Locomotive',
            children: <LocomotiveFM currentTab={tabToRender} />,
        },
    ]

    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Fuel Management</Grid>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Tabs activeKey={tabToRender} items={items} className='custom-tabs' onChange={(key) => setTabToRender(key)} />
                </div>
            </Grid>
        </PageLayout>

    )
}

export default FuelManagementMainPage